export default __webpack_public_path__ + "static/media/purpose.1c3580c2.png";